
import classNames from "classnames";
import PropTypes from "prop-types";

import { IconLeftChevronBold, IconRightChevronBold } from "icons";

import styles from "./Carousel.module.scss";

// NOTE: doesn't work, should revisit beyond P0
const handleKeyPress = (orientation, onClick) => e => {
  const keyCode = orientation === "left" ? 37 : 39;
  if (e.keyCode === keyCode) {
    onClick(e);
  }
};

const iconForOrientation = {
  left: IconLeftChevronBold,
  right: IconRightChevronBold,
};

// Arrow Component
function CarouselArrow({
  id,
  active,
  containerProps,
  className, // necessary for react-slick
  iconProps,
  onClick, // necessary for react-slick
  onMouseEnter,
  onMouseLeave,
  orientation,
}) {
  if (!active) {
    return null;
  }

  const containerClasses = classNames(
    className,
    styles.arrow_container,
    containerProps.rounded && styles.rounded,
    styles[containerProps.type],
    containerProps.pullUp && styles.pull_up,
    containerProps.position
      ? styles[`${orientation}-${containerProps.position}`]
      : styles[orientation],
  );

  const click = e => {
    // Need to stop propagation, or it'll trigger click tracking of parent container
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };

  const Icon = iconForOrientation[orientation];

  return (
    <button
      id={id}
      className={containerClasses}
      onClick={click}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onKeyPress={handleKeyPress(orientation, click)}
      data-orientation={orientation}
    >
      <div className={styles.icon_container}>
        <span className="sr-only">{orientation}</span>
        <Icon {...iconProps} />
      </div>
    </button>
  );
}

CarouselArrow.propTypes = {
  id: PropTypes.string,
  active: PropTypes.bool.isRequired,
  iconProps: PropTypes.object,
  containerProps: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func,
  orientation: PropTypes.oneOf(["left", "right"]).isRequired,
  position: PropTypes.oneOf(["adjacent", ""]),
};

CarouselArrow.defaultProps = {
  id: "",
  className: "",
  containerProps: {},
  iconProps: {},
  onClick: () => {},
  position: "",
};

export default CarouselArrow;
